import { createAction } from "../fns/createAction";
import { fns, libTypes } from "@holta/lib";
import { Product } from "@holta/lib/types";
import { feathersApp } from "../config/feathers";

export const setProducts = createAction("SET_PRODUCT_PRODUCTS", (newState, products: Product[]) => {
    newState.products = products;
});

